import Container from "../common/Container";
import Button from "../common/Button";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-bg" aria-hidden="true" />
      <div className="hero-grid" aria-hidden="true" />

      <Container className="hero-container">
        <div className="hero-inner">
          <div className="hero-eyebrow">
            <div className="hero-eyebrow-line" />
            <span>Frontend Engineer · Tirana, AL</span>
          </div>

          <h1 className="hero-name">
            Xhonatan
            <span className="line2">Hajdari</span>
          </h1>

          <p className="hero-desc">
            I build scalable, high-performance web experiences with a strong
            focus on usability, accessibility and clean architecture — turning
            complex problems into intuitive interfaces.
          </p>

          <div className="hero-cta">
            <Button href="#projects">View Work</Button>
            <Button href="#contact" variant="ghost">
              Get in touch
            </Button>
          </div>
        </div>

        <div className="hero-status">
          <span className="status-label">Current status</span>
          <div className="status-badge">
            <div className="status-dot" />
            Engineering modern digital experiences
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
